import React, { useState, useEffect, useCallback, useMemo } from 'react';

const Header: React.FC = () => {
  const [glitchText, setGlitchText] = useState('PaidNerd');

  // Memoize static arrays to prevent unnecessary re-renders
  const glitchChars = useMemo(() => '!<>-_\\/[]{}—=+*^?#________', []);

  // Optimized glitch effect with useCallback
  const glitchTextHandler = useCallback(() => {
    const companyName = 'PaidNerd';
    if (Math.random() < 0.1) { // 10% chance to glitch
      const glitched = companyName.split('').map((char: string) => 
        Math.random() < 0.3 ? glitchChars[Math.floor(Math.random() * glitchChars.length)] : char
      ).join('');
      setGlitchText(glitched);
      
      setTimeout(() => setGlitchText(companyName), 100);
    }
  }, [glitchChars]);

  useEffect(() => {
    const glitchInterval = setInterval(glitchTextHandler, 2000);
    return () => clearInterval(glitchInterval);
  }, [glitchTextHandler]);

  return (
    <header className="header">
      <div className="container">
        <nav className="navbar">
          <div className="logo-section">
            <div className="logo-container">
              <img                src="/PaidNerd-Logo-with-text-colored.svg" 
                alt="PaidNerd Logo"
                className="logo main-logo"
              />
              <div className="logo-glow"></div>
              <div className="holographic-overlay"></div>
            </div>
          </div>
          <div className="terminal-title">
            <span className="terminal-prompt">root@PaidNerd:~$</span>{' '}
            <span className="terminal-command typing-effect">./welcome.sh --initialize</span>
          </div>
        </nav>
        
        <div className="hero-section">
          <div className="terminal-window main-terminal">
            <div className="terminal-header">
              <div className="terminal-dots">
                <div className="terminal-dot red pulse"></div>
                <div className="terminal-dot yellow pulse"></div>
                <div className="terminal-dot green pulse"></div>
              </div>
              <span className="terminal-window-title">PaidNerd - Website Development Services</span>
              <div className="terminal-controls">
                <span className="terminal-control">⚡</span>
                <span className="terminal-control">📊</span>
                <span className="terminal-control">🔒</span>
              </div>
            </div>
            <div className="terminal-content">              <div className="terminal-line">
                <span className="terminal-prompt">PaidNerd@webdev:~$</span>{' '}
                <span className="terminal-command">whoami</span>
              </div>
              <div className="terminal-output">
                <span className="highlight-green">Professional Web Development Section at PaidNerd Agency</span>
                <div className="ascii-art">
{`+================================================================+
  🚀 Elite Web Development  •  🎨 Creative UI/UX  •  🛡️ Secure 
  ⚡ Lightning Performance  •  📱 Full Responsive  •  💻 Modern 
+================================================================+`}
                </div>
              </div>
              <br />              <div className="terminal-line">
                <span className="terminal-prompt">PaidNerd@webdev:~$</span>{' '}
                <span className="terminal-command">ls -la services/ --detailed</span>
              </div>
              <div className="terminal-output service-list">
                <div className="service-item">
                  <div className="service-item-row">
                    <div className="service-item-icon">📦</div>
                    <div className="service-item-title">enterprise-solutions/</div>
                  </div>
                  <div className="service-item-row">
                    <div className="service-item-count">24</div>
                    <div className="service-item-desc">Scalable, full-stack business applications</div>
                  </div>
                </div>
                <div className="service-item">
                  <div className="service-item-row">
                    <div className="service-item-icon">🛒</div>
                    <div className="service-item-title">ecommerce-platforms/</div>
                  </div>
                  <div className="service-item-row">
                    <div className="service-item-count">13</div>
                    <div className="service-item-desc">Robust e-commerce ecosystems</div>
                  </div>
                </div>
                <div className="service-item">
                  <div className="service-item-row">
                    <div className="service-item-icon">⭐</div>
                    <div className="service-item-title">premium-architecture/</div>
                  </div>
                  <div className="service-item-row">
                    <div className="service-item-count">37</div>
                    <div className="service-item-desc">Bespoke enterprise-grade solutions with microservices</div>
                  </div>
                </div>
                <div className="service-item">
                  <div className="service-item-row">
                    <div className="service-item-icon">🎨</div>
                    <div className="service-item-title">custom-ui-systems/</div>
                  </div>
                  <div className="service-item-row">
                    <div className="service-item-count">74</div>
                    <div className="service-item-desc">Tailored, responsive UI/UX with React, Angular & custom themes</div>
                  </div>
                </div>
              </div>
              <br /><div className="terminal-line">
                <span className="terminal-prompt">PaidNerd@webdev:~$</span>{' '}
                <span className="terminal-command">cat mission.txt | head -10</span>
              </div>
              <div className="terminal-output mission-display">
                <div className="mission-item">
                  <span className="highlight-green">🎯 Mission:</span> Architecting scalable, secure, and high-performance web solutions
                </div>
                <div className="mission-item">
                  <span className="highlight-cyan">💡 Expertise:</span> Full-stack development, API-driven architectures, and DevOps integration
                </div>
                <div className="mission-item">
                  <span className="highlight-yellow">🔥 Focus:</span> Modern, API-first designs with exceptional user experiences
                </div>
                <div className="mission-item">
                  <span className="highlight-purple">💎 Quality:</span> Pixel-perfect, SEO-optimized, and cross-platform compatibility
                </div>
                <div className="mission-item">
                  <span className="highlight-red">⚡ Performance:</span> Sub-second load times with advanced caching and CDN integration
                </div>
              </div>
              <br />              <div className="terminal-line">
                <span className="terminal-prompt">PaidNerd@webdev:~$</span>{' '}
                <span className="typing-animation">./explore_services.sh --interactive</span>
                <span className="cursor-blink">█</span>
              </div>              <div className="system-stats">
                <div className="stat-item">
                  <span className="stat-label">🔧 System Status:</span>
                  <div className="stat-value-row">
                    <span className="stat-value highlight-green">OPERATIONAL</span>
                    <button className="btn-status status-active" title="System Status">
                      <span className="status-dot"></span>
                      OK
                    </button>
                  </div>
                </div>
                <div className="stat-item">
                  <span className="stat-label">📊 Performance:</span>
                  <div className="stat-value-row">
                    <span className="stat-value highlight-cyan">99.9% Uptime</span>
                    <button className="btn-icon" title="Performance Monitor">📈</button>
                  </div>
                </div>
                <div className="stat-item">
                  <span className="stat-label">🛡️ Security:</span>
                  <div className="stat-value-row">
                    <span className="stat-value highlight-yellow">Enterprise Grade</span>
                    <button className="btn-icon" title="Security Status">🔒</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
